<aur-mat-table
  [tableData]="tableData"
  [tableConfig]="tableConfig"
>
    <div ngxAurTableSubFooterRow>
      <p>!!!! SUB FOOTER ROW !!!!</p>
    </div>
</aur-mat-table>

